import ResultsInfo from './ResultsInfo.container';

export default ResultsInfo;
